import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { defineCustomElements } from '@teamhive/lottie-player/loader';

import { AppModule } from './app.module';

defineCustomElements(window);

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/app/main.ts